import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { WinService } from 'src/app/services/win.service'; 
import { LangService } from 'src/app/services/lang/lang.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from 'src/app/services/session.service';
import { CmsService } from 'src/app/services/api/cms.service';

@Component({
  selector: 'app-uses',
  templateUrl: './uses.component.html',
  styleUrls: ['./uses.component.scss']
})
export class UsesComponent implements OnInit {
  res: any;

  constructor(
    public winService : WinService,
    public lang : LangService,
    private title : Title,
    private activeRoute: ActivatedRoute,
    private sessionService : SessionService,
    private router : Router,
    public cms: CmsService,
  ) { }

  public uses: any;

  ngOnInit() {
    // this.title.setTitle('Entrelabel Samples');
    this.cms.getPage(8, false, false).then(res => {
      this.res = res;
      window.scrollTo(0, 0);
    });

    this.uses = [
      {
        uses_title: 'Beer labels', 
        uses_img: '',
      },
      {
        uses_title: 'Shipping bags', 
        uses_img: '',
      },
      {
        uses_title: 'Shipping tapes', 
        uses_img: '',
      },
      {
        uses_title: 'Beer labels', 
        uses_img: '',
      },
      {
        uses_title: 'Shipping bags', 
        uses_img: '',
      },
      {
        uses_title: 'Shipping tapes', 
        uses_img: '',
      },
    ]
  }

}
